import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutMessageFormFields {

    public name: FormField
    public description: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          false,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )

    }
}

const fields = new PutMessageFormFields()

export const putMessageFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
};